// extracted by mini-css-extract-plugin
export var aboveInput = "_k2-0";
export var actionButton = "_k2-5";
export var actionButtonContainer = "_k2-1";
export var actionIcon = "_k2-6";
export var aiInfoContainer = "_k2-2";
export var attachmentWrapper = "_k2-7";
export var bold = "_k2-3";
export var checkIcon = "_k2-8";
export var clickingRecipientBar = "_k2-11";
export var commentThreadSwitch = "_k2-a";
export var draftImage = "_k2-b";
export var draftImageContainer = "_k2-c";
export var draftImages = "_k2-e";
export var editButton = "_k2-g";
export var editor = "_k2-f";
export var editorContainer = "_k2-y";
export var editorErrorTooltipWrapper = "_k2-9";
export var headerDivider = "_k2-h";
export var icon = "_k2-i";
export var info = "_k2-j";
export var internal = "_k2-n";
export var internalDivider = "_k2-k";
export var internalMessage = "_k2-l";
export var messageInputCard = "_k2-m";
export var messageInputForm = "_k2-o";
export var messageInputFormInternal = "_k2-p";
export var options = "_k2-q";
export var publicMessageCustomer = "_k2-s";
export var publicMessageMerchant = "_k2-r";
export var removeImageButton = "_k2-d";
export var replyButtons = "_k2-t";
export var showSignatureButton = "_k2-u";
export var spinner = "_k2-v";
export var verticalButtonDivider = "_k2-4";
export var visibilitySelector = "_k2-w";
export var warning = "_k2-x";
export var wrappingText = "_k2-z";
export var writingInternalNoteTopBorder = "_k2-10";